import { defineStore } from "pinia";
import moment from "moment";
import {
  processCart,
  validateProduct,
  nuevaVenta,
  showPayButton,
  cancelarVenta,
  actualizarVenta,
  cambiarMetodoPago,
} from "@api/cart_api.js";

import {
  encriptar,
  desencriptar,
  encriptarCampo,
} from "@composables/use_encript.js";
import { authStore } from "@stores/auth_store.js";

function autenticacionRequerida(response) {
  const body = response && response.data;
  return body && body.message === "Autenticación requerida";
}

function mostrarErrorVenta(response) {
  if (autenticacionRequerida(response)) {
    authStore().pedirLoginPorSesion();
    return false;
  }
  const body = response && response.data;
  let message = "No se registró la compra. Podés reintentar.";
  if (body && body.message) {
    message = body.message;
  } else if (response && response.code === 0) {
    message = "No pudimos confirmar. Reintentá.";
  }
  const loading = document.getElementById("loading");
  const loadingText = document.getElementById("loadingText");
  if (loading) loading.classList.remove("d-none");
  if (loadingText) loadingText.innerHTML = message;
  const box = document.getElementById("msgNoDisponibilidad");
  if (box) {
    if (body && Array.isArray(body.productos) && body.productos.length) {
      box.classList.remove("hidden");
      box.classList.remove("d-none");
      const texto = box.querySelector("p");
      if (texto) {
        texto.innerHTML = body.productos
          .map((p) => `${p.nombre || p.ppId}: máximo ${p.maximo}`)
          .join("<br/>");
      }
    }
  }
  return false;
}

export const shoppingCartStore = defineStore("shoppingCartStore", {
  state: () => ({
    loadingShoppingCart: false,
    showShoppingCart: false,
    shoppingCartItems: [],
    shoppingCartItemCount: 0,
    shoppingCartTotal: 0,
    idVenta: "",
    tipoPago: "",
  }),
  actions: {
    async expiredCheck() {
      if (typeof Storage !== undefined) {
        if (
          (localStorage.getItem(encriptarCampo("basterShopingCart")) &&
            desencriptar(
              localStorage.getItem(encriptarCampo("basterShopingCart"))
            ) !== "[]") ||
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) !== []
        ) {
          this.shoppingCartItems =
            JSON.parse(
              desencriptar(
                localStorage.getItem(encriptarCampo("basterShopingCart"))
              )
            ) == null
              ? []
              : JSON.parse(
                  desencriptar(
                    localStorage.getItem(encriptarCampo("basterShopingCart"))
                  )
                );

          console.log(
            "this.shoppingCartItems on expiredCheck shopping_cart_store.js"
          );
          console.log(this.shoppingCartItems);

          let countExpired = 0;
          let productosExpired = [];

          this.shoppingCartItems.forEach((item) => {
            if (moment() >= moment(item.expires)) {
              countExpired++;
              productosExpired.push(item.item.name);
              this.removeFromShoppingCart(item);
            }
          });

          if (countExpired > 0) {
            let strProdctsName = "";
            productosExpired.forEach((item) => {
              strProdctsName += " * " + item + "\n";
            });
            let strMsg =
              "Tienes " +
              countExpired +
              " producto(s) que han expirado en el carrito de compras y han sido quitados:\n\n" +
              strProdctsName;
            alert(strMsg);
            this.initShoppingCart();
          }
        }
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async initShoppingCart() {
      console.log("initShoppingCart");
      if (typeof Storage !== undefined) {
        if (
          (localStorage.getItem(encriptarCampo("basterShopingCart")) &&
            desencriptar(
              localStorage.getItem(encriptarCampo("basterShopingCart"))
            ) !== []) ||
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) !== "[]"
        ) {
          this.shoppingCartItems =
            JSON.parse(
              desencriptar(
                localStorage.getItem(encriptarCampo("basterShopingCart"))
              )
            ) == null
              ? []
              : JSON.parse(
                  desencriptar(
                    localStorage.getItem(encriptarCampo("basterShopingCart"))
                  )
                );

          let qtty = 0;
          let total = 0;
          this.shoppingCartItems.forEach((item) => {
            qtty++;
            total += parseInt(item.qtty) * (item.price * 1);
          });

          this.shoppingCartItemCount = qtty;
          this.shoppingCartTotal = total;
        }
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async toggleShoppingCartModal() {
      this.showShoppingCart = !this.showShoppingCart;
      if (!this.showShoppingCart) {
        this.resetShoppingCart();
      }
    },

    showShoppingCartModal() {
      this.showShoppingCart = true;
    },

    hideShoppingCartModal() {
      this.showShoppingCart = false;
    },

    async resetShoppingCart() {
      if (typeof Storage !== undefined) {
        this.shoppingCartItems = [];
        this.shoppingCartItemCount = 0;
        this.shoppingCartTotal = 0;
        this.idVenta = "";
        this.tipoPago = "";
        localStorage.setItem(
          encriptarCampo("basterShopingCart"),
          JSON.stringify(encriptar(this.shoppingCartItems))
        );
        localStorage.setItem(encriptarCampo("saleId"), encriptar(""));
        localStorage.setItem(encriptarCampo("preferenceId"), encriptar(""));
        localStorage.setItem(encriptarCampo("checkoutId"), encriptar(""));
        localStorage.setItem(
          encriptarCampo("cartModified"),
          encriptar("false")
        );
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async addToShoppingCart(product) {
      if (typeof Storage !== undefined) {
        let item = {
          id: product.id,
          ppId: "valor de prueba",
          Presentacion: "valor de prueba",
          item: product,
          price: product.price,
          qtty: 1,
          expires: moment().add(12, "hours"),
        };

        if (
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) === null ||
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) === ""
        ) {
          this.shoppingCartItems = [item];
          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar(this.shoppingCartItems))
          );
        } else {
          let index = this.shoppingCartItems.findIndex(
            (item) => item.ppId == product.ppId && item.Presentacion == product.Presentacion
          );

          if (index != -1) {
            this.shoppingCartItems[index].qtty += 1;
            this.shoppingCartItems[index].expires = moment().add(12, "hours");
          } else {
            this.shoppingCartItems.push(item);
          }

          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar(this.shoppingCartItems))
          );
          localStorage.setItem(
            "basterShopingCart",
            JSON.stringify(this.shoppingCartItems)
          );
        }
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async removeFromShoppingCart(product) {
      let auxCart = [];
      if (typeof Storage !== undefined) {
        auxCart = JSON.parse(
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          )
        );
        auxCart = auxCart.filter((item) => item.ppId != product.ppId);

        localStorage.setItem(
          encriptarCampo("basterShopingCart"),
          JSON.stringify(encriptar(auxCart))
        );
        if (auxCart == []) {
          this.resetShoppingCart();
        }
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async updateShoppingCart(
      product,
      qtty,
      ppId,
      Presentacion,
      PreciosPresentacion
    ) {
      let auxCart = [];

      if (typeof Storage !== undefined) {
        let thePrice = 0;
        let theOriginalPrice = 0;
        let thePriceDiscount = 0;

        PreciosPresentacion.forEach((price) => {
          if (qtty >= price.Min) {
            thePrice = price.Price * 1;
            theOriginalPrice = thePrice;
            if (price.promo_descuento_perc != 0 && price.show_promo) {
              theOriginalPrice = price.Price;
              thePriceDiscount = price.promo_descuento_perc;
              thePrice =
                price.Price - (price.Price * price.promo_descuento_perc) / 100;
            }
          }
        });

        let item = {
          id: product.id,
          ppId: ppId,
          Presentacion: Presentacion,
          PreciosPresentacion: PreciosPresentacion,
          item: product,
          price: thePrice,
          originalPrice: theOriginalPrice,
          priceDiscount: thePriceDiscount,
          qtty: qtty,
          categoria_pago_requerido: product.categoria_pago_requerido,
          subCategoria_pago_requerido: product.subCategoria_pago_requerido,
          expires: moment().add(12, "hours"),
        };

        if (
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) === null ||
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          ) === ""
        ) {
          auxCart = [item];
          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar(auxCart))
          );
        } else {
          auxCart = JSON.parse(
            desencriptar(
              localStorage.getItem(encriptarCampo("basterShopingCart"))
            )
          );

          let index = auxCart.findIndex((item) => item.ppId == ppId && item.Presentacion == Presentacion);

          if (index != -1) {
            if (qtty > 0) {
              let thePrice2 = 0;
              let theOriginalPrice2 = 0;
              let thePriceDiscount2 = 0;
              auxCart[index].PreciosPresentacion.forEach((price) => {
                if (qtty >= price.Min) {
                  thePrice2 = price.Price * 1;
                  theOriginalPrice2 = thePrice2;
                  if (price.promo_descuento_perc != 0 && price.show_promo) {
                    thePrice2 =
                      price.Price -
                      (price.Price * price.promo_descuento_perc) / 100;
                  }
                  theOriginalPrice2 = price.Price;
                  thePriceDiscount2 = price.promo_descuento_perc;
                }
              });

              auxCart[index].qtty = qtty;
              auxCart[index].expires = moment().add(12, "hours");
              auxCart[index].price = thePrice2;
              auxCart[index].originalPrice = theOriginalPrice2;
              auxCart[index].priceDiscount = thePriceDiscount2;
            } else {
              auxCart = auxCart.filter((item) => item.ppId != ppId);
            }
          } else {
            auxCart.push(item);
          }

          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar(auxCart))
          );
        }
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async mostrarDisponibilidad(data) {
      let auxCart = [];
      if (typeof Storage !== undefined) {
        data.forEach((product) => {
          auxCart = JSON.parse(
            desencriptar(
              localStorage.getItem(encriptarCampo("basterShopingCart"))
            )
          );

          let index = auxCart.findIndex((item) => item.ppId == product.ppId);
          if (index != -1) {
            var antAvailable = auxCart[index].available;
            auxCart[index].available = product.stock;
            auxCart[index].qtty = product.qtty;
          }
          localStorage.setItem(
            encriptarCampo("basterShopingCart"),
            JSON.stringify(encriptar(auxCart))
          );

          if (
            typeof antAvailable == "undefined" &&
            product.qtty > product.stock
          ) {
            document
              .getElementById("idDivAvStock_" + product.ppId)
              .classList.remove("d-none");
            document.getElementById("idAvStock_" + product.ppId).innerHTML =
              "Cantidad máxima disponible: " + product.stock + " unidades";
          }
        });
      } else {
        alert("Almacenamiento local no disponible!!!");
      }
    },

    async updateData() {
      this.shoppingCartItems =
        JSON.parse(
          desencriptar(
            localStorage.getItem(encriptarCampo("basterShopingCart"))
          )
        ) == null
          ? []
          : JSON.parse(
              desencriptar(
                localStorage.getItem(encriptarCampo("basterShopingCart"))
              )
            );

      let qtty = 0;
      let total = 0;
      this.shoppingCartItems.forEach((item) => {
        qtty++;
        total += parseInt(item.qtty) * (item.price * 1);
      });

      this.shoppingCartItemCount = qtty;
      this.shoppingCartTotal = total;
    },

    async processCart(data) {
      const response = await processCart(data);

      switch (response.code) {
        case 403:
          return mostrarErrorVenta(response);
          break;
        case 401:
          return mostrarErrorVenta(response);
          break;
        case 402:
          return mostrarErrorVenta({
            data: {
              message: "No hay productos en el almacén de pirotecnia",
            },
          });
          break;
        case 423:
          return mostrarErrorVenta(response);
          break;
        default:
          if (response.status === 200) {
            return response.data;
          } else {
            return mostrarErrorVenta(response);
          }
      }
    },

    async validateProduct(data) {
      const response = await validateProduct(data);

      switch (response.code) {
        case 403:
          alert("Error en la entrada de datos");
          return false;
          break;
        case 401:
          if (autenticacionRequerida(response)) {
            authStore().pedirLoginPorSesion();
            return false;
          }
          alert("Autenticación requerida");
          return false;
          break;
        case 402:
          alert("No hay productos en el almacén de pirotecnia");
          return false;
          break;
        case 423:
          alert("Error al procesar los datos del producto");
          return false;
          break;
        default:
          if (response.status === 200) {
            return response.data;
          } else {
            alert("Error al procesar los datos del producto");
            return false;
          }
      }
    },

    async cancelarVenta(data) {
      const response = await cancelarVenta(data);

      switch (response.code) {
        case 403:
          alert("Error en la entrada de datos");
          return false;
          break;
        case 401:
          if (autenticacionRequerida(response)) {
            authStore().pedirLoginPorSesion();
            return false;
          }
          alert("Autenticación requerida");
          return false;
          break;
        case 423:
          alert("Error al cancelar la venta");
          return false;
          break;
        default:
          if (response.status === 200) {
            return response.data;
          } else {
            alert("Error al cancelar la venta");
            return false;
          }
      }
    },

    async nuevaVenta(data) {
      const response = await nuevaVenta(data);
      switch (response.code) {
        case 403:
          return mostrarErrorVenta(response);
          break;
        case 401:
          return mostrarErrorVenta(response);
          break;
        case 423:
          return mostrarErrorVenta(response);
          break;
        default:
          if (response.status === 200) {
            if (data.tipoPago == "MercadoPago") {
              document.getElementById("loadingText").innerHTML =
                "Venta realizada (No. " +
                response.data +
                ") <br/> Procediendo a realizar el pago";
              return response;
            } else {
              let spinner = document.getElementById("loadingSpinner");
              if (spinner) {
                spinner.classList.add("d-none");
              }
              let loadingText = document.getElementById("loadingText");
              if (loadingText) {
                loadingText.classList.add("d-none");
                document.getElementById("loadingText").innerHTML =
                  "Venta realizada (No. " + response.data + ")";
              }

              this.idVenta = response.data;
              this.tipoPago = data.tipoPago;
            }

            return true;
          } else {
            return mostrarErrorVenta(response);
          }
      }
    },

    setTipoPago(tipoPago) {
      this.tipoPago = tipoPago;
    },

    async actualizarVenta(data) {
      const response = await actualizarVenta(data);
      switch (response.code) {
        case 403:
          return mostrarErrorVenta(response);
          break;
        case 401:
          return mostrarErrorVenta(response);
          break;
        case 423:
          return mostrarErrorVenta(response);
          break;
        default:
          if (response.status === 200) {
            if (data.tipoPago == "MercadoPago") {
              document.getElementById("loadingText").innerHTML =
                "Venta actualizada (No. " +
                response.data +
                ") <br/> Procediendo a realizar el pago";
              return response;
            } else {
              document
                .getElementById("loadingSpinner")
                ?.classList.add("d-none");
              document.getElementById("loadingText")?.classList.add("text-end");
              document.getElementById("loadingText").innerHTML =
                "Venta actualizada (No. " + response.data + ")";
              this.idVenta = response.data;
              this.tipoPago = data.tipoPago;
            }
            return true;
          } else {
            return mostrarErrorVenta(response);
          }
      }
    },

    async cambiarMetodoPago(data) {
      const response = await cambiarMetodoPago(data);

      switch (response.code) {
        case 403:
          alert("Error en la entrada de datos");
          return false;
          break;
        case 401:
          if (autenticacionRequerida(response)) {
            authStore().pedirLoginPorSesion();
            return false;
          }
          alert("Autenticación requerida");
          return false;
          break;
        case 402:
          alert("Error en el método de Pago");
          return false;
          break;
        case 423:
          alert("Error al cambiar el método de Pago");
          return false;
          break;
        default:
          if (response.status === 200) {
            return response.data;
          } else {
            alert("Error al cambiar el método de Pago");
            return false;
          }
      }
    },

    async MPButtonPay(data, response) {
      //Payload to pay-button
      var myCartItems = {};
      var cartItems = [];

      for (let i = 0; i < data.cartItems.length; i++) {
        const line = data.cartItems[i];
        const qty = parseInt(line.qtty);
        const price = parseFloat(line.price);
        cartItems[i] = {
          id: line.ppId,
          name: line.name,
          qty: qty,
          price: price,
          PresentacionProductoId: line.ppId,
          total: price * qty,
        };
      }
      myCartItems.cartItems = cartItems;

      if (typeof Storage !== undefined) {
        var email =
          desencriptar(localStorage.getItem(encriptarCampo("email"))) !== ""
            ? desencriptar(localStorage.getItem(encriptarCampo("email")))
            : null;
      } else {
        return alert("Almacenamiento local no disponible!!!");
      }

      let myData = {
        cartItems: myCartItems.cartItems,
        saleId: response.data,
        email: email,
      };
      return await showPayButton(myData);
    },
  },
});
